import styled from "styled-components";

export const TheDirectWrapper = styled.div`
    width: 1000px;
    margin: 0 auto;
    @media screen and (max-width: 750px) {
        width: 100%;
    }
`;

export const VideoContentWrapper = styled.div`
    background-color: #e3e3e3;
    padding: 8px;
    @media screen and (max-width: 750px) {
        .ant-col-18 {
            flex: 100%;
            max-width: 100%;
        }
        .ant-col-6 {
            flex: 100%;
            max-width: 100%;
        }
    }
`;

export const VideoContent = styled.div`
    .videoBox {
        position: relative;
        .posterImage {
            display: block;
            width: 100%;
        }
        .play {
            position: absolute;
            left: 5%;
            bottom: 5%;
            cursor: pointer;
        }
        .videoWrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: black;
            display: none;
            .myVideo {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
    .textBox {
        background-color: #764eb3;
        padding: 15px 30px;
        h2 {
            color: white;
            font-size: 25px;
        }
        p {
            color: white;
            font-size: 16px;
            display: none;
        }
    }
    @media screen and (max-width: 750px) {
        .videoBox {
            .play {
                width: 10%;
            }
        }
        .textBox {
            display: none;
            padding: 10px;

            h2 {
                font-size: 18px;
            }
            p {
                font-size: 14px;
            }
        }
    }
`;

export const VideoList = styled.ul`
    li {
        background-color: #a2a6b8;
        font-size: 16px;
        padding: 10px;
        margin-bottom: 8px;
        cursor: pointer;
        color: white;
        transition: all 0.5s;
        position: relative;
        padding-left: 20px;
        .icon {
            position: absolute;
            width: 0;
            height: 0;
            border-top 10px solid transparent;
            border-bottom 10px solid transparent;
            border-left: 12px solid #e3e3e3;
            top: 50%;
            transform: translateY(-50%);
            left: 0px;
            display: none;
        }
    }
    li.current {
        background-color: #764eb3;
        .icon {
            display: block;
        }
    }
    @media screen and (max-width: 750px) {

    }
`;
